import IsibuteDocumentComponent from "./IsibuteDocumentComponent";

class IsibuteDocumentResumeEntryDateRange extends IsibuteDocumentComponent {};

export default IsibuteDocumentResumeEntryDateRange;
